import { render, staticRenderFns } from "./bomPart.vue?vue&type=template&id=3b16fe4f&scoped=true&"
import script from "./bomPart.vue?vue&type=script&lang=js&"
export * from "./bomPart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b16fe4f",
  null
  
)

export default component.exports